export const STUDENT_FIELDS = {
  personal: [
    { name: 'firstName', label: 'First Name', grid: 4 },
    { name: 'middleName', label: 'Middle Name', grid: 4 },
    { name: 'lastName', label: 'Last Name', grid: 4 },
    { name: 'email', label: 'Email', grid: 6 },
    { name: 'phone', label: 'Phone', grid: 6 },
    { name: 'dateOfBirth', label: 'Date of Birth', grid: 6, type: 'date' },
    { name: 'placeOfBirth', label: 'Place of Birth', grid: 6 },
    { name: 'gender', label: 'Gender', grid: 6 },
    { name: 'bloodGroup', label: 'Blood Group', grid: 6, isRelation: true },
    { name: 'examBoard', label: 'Exam Board', grid: 6, isRelation: true },
    { name: 'aadharNumber', label: 'Aadhar Number', grid: 6 },
    { name: 'nationality', label: 'Nationality', grid: 6, isRelation: true },
    { name: 'motherTongue', label: 'Mother Tongue', grid: 6, isRelation: true },
    { name: 'category', label: 'Category', grid: 6, isRelation: true },
    { name: 'caste', label: 'Caste', grid: 6, isRelation: true },
    { name: 'religion', label: 'Religion', grid: 6, isRelation: true },
    { name: 'house', label: 'House', grid: 6, isRelation: true },
    { name: 'medium', label: 'Medium', grid: 6, isRelation: true },
  ],
  academic: [
    { name: 'class', label: 'Class', grid: 6, isRelation: true },
    { name: 'section', label: 'Section', grid: 6, isRelation: true },
    { name: 'admissionDate', label: 'Admission Date', grid: 6, type: 'date' },
    { name: 'studentType', label: 'Student Type', grid: 6, isRelation: true },
    { name: 'rte', label: 'RTE Student', grid: 6, type: 'boolean' },
    { name: 'bpl', label: 'BPL Student', grid: 6, type: 'boolean' },
    { name: 'admissionNumber', label: 'Admission Number', grid: 6 },
    { name: 'scholarNumber', label: 'Scholar Number', grid: 6 },
  ],
  parent: {
    father: [
      { name: 'fatherName', label: 'Name', grid: 6 },
      { name: 'fatherMobile', label: 'Mobile', grid: 6 },
      { name: 'fatherOccupation', label: 'Occupation', grid: 6, isRelation: true },
      { name: 'fatherQualification', label: 'Qualification', grid: 6 },
      { name: 'fatherAnnualIncome', label: 'Annual Income', grid: 6 },
    ],
    mother: [
      { name: 'motherName', label: 'Name', grid: 6 },
      { name: 'motherMobile', label: 'Mobile', grid: 6 },
      { name: 'motherOccupation', label: 'Occupation', grid: 6, isRelation: true },
      { name: 'motherQualification', label: 'Qualification', grid: 6 },
      { name: 'motherAnnualIncome', label: 'Annual Income', grid: 6 },
    ],
    guardian: [
      { name: 'guardianName', label: 'Name', grid: 6 },
      { name: 'guardianMobile', label: 'Mobile', grid: 6 },
      { name: 'guardianEmail', label: 'Email', grid: 6 },
      { name: 'guardianRelation', label: 'Relation', grid: 6, isRelation: true },
      { name: 'guardianAddress', label: 'Address', grid: 12 },
    ]
  },
  previousSchool: [
    { name: 'schoolName', label: 'School Name', grid: 12 },
    { name: 'board', label: 'Board', grid: 6, isRelation: true },
    { name: 'passingYear', label: 'Passing Year', grid: 6, type: 'number' },
    { name: 'previousClass', label: 'Class', grid: 6 },
    { name: 'medium', label: 'Medium', grid: 6, isRelation: true },
    { name: 'result', label: 'Result', grid: 6 },
    { name: 'tcNumber', label: 'TC Number', grid: 6 },
    { name: 'tcDate', label: 'TC Date', grid: 6, type: 'date' },
    { name: 'leavingReason', label: 'Leaving Reason', grid: 6, isRelation: true },
  ],
  address: [
    { name: 'addressLine1', label: 'Address Line 1', grid: 12 },
    { name: 'addressLine2', label: 'Address Line 2', grid: 12 },
    { name: 'city', label: 'City', grid: 6 },
    { name: 'district', label: 'District', grid: 6 },
    { name: 'state', label: 'State', grid: 6 },
    { name: 'pincode', label: 'Pincode', grid: 6 },
    { name: 'country', label: 'Country', grid: 6 },
  ]
};
